import { reactive } from 'vue'

const MAX_TOASTS = 1
let idCounter = 0
const timers = new Map()

export const toastState = reactive({
  items: [],
})

function dismissToast(id) {
  const timer = timers.get(id)
  if (timer) {
    clearTimeout(timer)
    timers.delete(id)
  }
  const index = toastState.items.findIndex((item) => item.id === id)
  if (index >= 0) {
    toastState.items.splice(index, 1)
  }
}

function findDuplicateToast(message, type) {
  return toastState.items.find(
    (item) => item.message === String(message) && item.type === type,
  )
}

/**
 * Show a lightweight in-app toast (all environments).
 */
export function showAppToast(options = {}) {
  const {
    message,
    type = 'info',
    duration = 1800,
    title,
  } = options

  if (!message) return null

  const text = title ? `${title} · ${message}` : String(message)
  const timeout = Math.max(1200, Number(duration) || 1800)

  const duplicate = findDuplicateToast(text, type)
  if (duplicate) {
    const oldTimer = timers.get(duplicate.id)
    if (oldTimer) clearTimeout(oldTimer)
    timers.set(
      duplicate.id,
      setTimeout(() => dismissToast(duplicate.id), timeout),
    )
    duplicate.duration = timeout
    duplicate.bumpCount = (duplicate.bumpCount || 0) + 1
    return duplicate.id
  }

  const id = ++idCounter
  const item = {
    id,
    type,
    message: text,
    duration: timeout,
    bumpCount: 0,
  }

  toastState.items.push(item)
  if (toastState.items.length > MAX_TOASTS) {
    const removed = toastState.items.shift()
    if (removed) dismissToast(removed.id)
  }

  timers.set(
    id,
    setTimeout(() => dismissToast(id), timeout),
  )

  return id
}

export function removeAppToast(id) {
  dismissToast(id)
}

export function clearAppToasts() {
  [...toastState.items].forEach((item) => dismissToast(item.id))
}
